<!-- 项目特点-另一种弹窗展示样式 -->
<template>
  <div>
    <zlr-modal v-model="projectModal">
      <div style="width:960px">
        <div v-if="detail.length > 0">
          <pre v-if="!isArray">{{detail}}</pre>
          <div v-if="isArray">
            <div v-for="(item, index) in detail" :key="index" class="content-item">
              <div v-if="item.isShow && item.value">
                <h3 class="content-title">{{item.title}}：</h3>
                <p class="content-desc">{{item.value}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="btn">
          <Button type="primary"
                  class="zlr-btn-primary"
                  @click="projectModal = false">关闭</Button>
        </div>
      </div>
    </zlr-modal>
  </div>
</template>

<script>
// components
import ZlrModal from '_c/modal/modal'
export default {
  name: '',
  components: {
    ZlrModal
  },
  data () {
    return {
      projectModal: false,
      detail: [],
      isArray: false
    }
  },
  computed: {},
  mounted () { },
  methods: {
    show (data) {
      this.isArray = Array.isArray(data)
      console.log(data)
      this.detail = data
      this.projectModal = true
    }
  }
}
</script>
<style lang='less' scoped>
.btn {
  text-align: right;
  margin-top: 24px;
}
.content-item {
  padding-bottom: 15px;
  .content-title {
    font-weight: normal;
    color: rgb(101, 137, 221);
  }
  .content-desc {
    font-size: 14px;
    text-indent: 28px;
    line-height: 20px;
  }
}
</style>
